import { createPromise } from "./promise.js";
import { setTimeout } from "./window.js";
/**
 * @todo TODO consider max delay
 * @param {number} ms
 */
export const sleep = (ms) => createPromise((resolve) => setTimeout(resolve, ms));
